import './index.css'

export default function index() {
  return <div className="main_header"></div>
}
